/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Basic_Payment_DescriptionInputs */

const en_admin_settings_groups_basic_payment_description = /** @type {(inputs: Admin_Settings_Groups_Basic_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment general settings`)
};

/**
* | output |
* | --- |
* | "Payment general settings" |
*
* @param {Admin_Settings_Groups_Basic_Payment_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_basic_payment_description = /** @type {((inputs?: Admin_Settings_Groups_Basic_Payment_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Basic_Payment_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_basic_payment_description(inputs)
});
export { admin_settings_groups_basic_payment_description as "admin.settings.groups.basic_payment.description" }